export const PauseIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_71_13)">
      <path d="M6 19H10V5H6V19ZM14 5V19H18V5H14Z" />
    </g>
    <defs>
      <clipPath id="clip0_71_13">
        <rect width="24" height="24" />
      </clipPath>
    </defs>
  </svg>
);
